import { render, staticRenderFns } from "./LedgerFinance.vue?vue&type=template&id=5a60ce82&"
import script from "./LedgerFinance.vue?vue&type=script&lang=js&"
export * from "./LedgerFinance.vue?vue&type=script&lang=js&"
import style0 from "./LedgerFinance.vue?vue&type=style&index=0&id=5a60ce82&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports